import type { BrainSession } from '@/types/brain'

interface SessionListProps {
  sessions: BrainSession[]
  activeSessionId: string | null
  onSelect: (id: string) => void
  onNew: () => void
  isLoading: boolean
}

function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

export function SessionList({
  sessions,
  activeSessionId,
  onSelect,
  onNew,
  isLoading,
}: SessionListProps) {
  return (
    <div className="w-[280px] border-r border-swiss-gray-200 bg-swiss-off-white h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-swiss-gray-200">
        <span className="font-swiss-mono text-swiss-label uppercase tracking-[0.1em] text-swiss-gray-500">
          Sessions
        </span>
        <button
          onClick={onNew}
          className="font-swiss-mono text-swiss-caption text-swiss-black hover:underline"
        >
          + New
        </button>
      </div>

      {/* List */}
      <div className="flex-1 overflow-y-auto">
        {isLoading ? (
          <div className="font-swiss-mono text-swiss-caption text-swiss-gray-500 p-4 text-center">
            Loading sessions...
          </div>
        ) : sessions.length === 0 ? (
          <div className="font-swiss-mono text-swiss-caption text-swiss-gray-500 p-4 text-center">
            No sessions yet
          </div>
        ) : (
          sessions.map((session) => {
            const isActive = session.id === activeSessionId
            return (
              <button
                key={session.id}
                onClick={() => onSelect(session.id)}
                className={[
                  'w-full text-left px-4 py-3 border-b border-swiss-gray-100 hover:bg-swiss-gray-100 block',
                  isActive ? 'bg-swiss-white border-l-2 border-l-swiss-black' : '',
                ].join(' ')}
              >
                <div className="font-swiss-mono text-swiss-caption text-swiss-gray-500">
                  {session.project}
                </div>
                <div className="text-swiss-small text-swiss-gray-700 mt-0.5">
                  {truncate(session.preview || session.id.slice(0, 8), 60)}
                </div>
              </button>
            )
          })
        )}
      </div>
    </div>
  )
}
